// extracted by mini-css-extract-plugin
module.exports = {"pageName":"AddSupplierComponent_pageName__LA6ow","header":"AddSupplierComponent_header__Q9dBp","backButton":"AddSupplierComponent_backButton__38lzZ"};